import Badge from "../../../components/ui/Badge";
import { SESSION_STATUS } from "../sessionUtils";

// VALID is the normal case, so it is hidden unless `showValid`.
const SessionStatusBadge = ({ status, showValid = false }) => {
  if (!status || (status === "VALID" && !showValid)) return null;
  const config = SESSION_STATUS[status] ?? { label: status, tone: "gray" };

  return (
    <Badge tone={config.tone} icon={config.icon}>
      {config.label}
    </Badge>
  );
};

export default SessionStatusBadge;
